import React from 'react';
import { useNavigate } from 'react-router-dom';
import notFoundImage from '../../assets/images/404.png';
const PageNotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate('/');
  };

  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-90 text-center p-4">
      <img
        src={notFoundImage}
        alt="Página não encontrada"
        style={{ maxWidth: '300px', marginBottom: '20px' }}
      />
      <h4 className="fw-bold mb-2">Página não encontrada</h4>
      <p className="text-muted mb-3" style={{ maxWidth: '400px' }}>
        A página que você está procurando não existe ou foi movida.<br />
        Você pode voltar para a página inicial ou tentar novamente mais tarde.
      </p>
      <button className="btn btn-primary" onClick={handleBackToHome}>
        Voltar para a página inicial
      </button>
    </div>
  );
};

export default PageNotFound;